import { convertToObject } from "./convertToObject";

export const addressValues = [
  "route",
  "street_number",
  "postal_code",
  "sublocality_level_1",
  "locality",
  "administrative_area_level_1",
  "country",
];

export const validateAddress = (obj, arrayValues) => {
  return arrayValues.every((item) => Object.prototype.hasOwnProperty.call(obj, item));
};

// El alta de empleados no requiere calle y número: hay ubicaciones sin esos
// componentes en Google Maps y de todos modos se pueden capturar a mano.
export const employeeAddressValues = [
  "postal_code",
  "sublocality_level_1",
  "locality",
  "administrative_area_level_1",
];

export const validateEmployeeAddress = (obj) =>
  validateAddress(obj, employeeAddressValues);

// Arma la dirección de un empleado a partir de los address_components de Google,
// contemplando las variantes con las que nombra colonia y municipio.
export const buildEmployeeAddress = (addressComponents = []) => {
  const components = convertToObject(addressComponents, "long_name", "types");

  // Solo se devuelven las llaves que Google si trajo: las vacias se omiten
  // para no pisar lo que el usuario ya haya capturado a mano en el formulario.
  const address = {
    route: components.route,
    street_number: components.street_number,
    postal_code: components.postal_code,
    sublocality_level_1:
      components.sublocality_level_1 ||
      components.sublocality ||
      components.neighborhood,
    locality: components.locality || components.administrative_area_level_2,
    administrative_area_level_1: components.administrative_area_level_1,
  };

  return Object.entries(address).reduce((acc, [key, value]) => {
    if (value) acc[key] = value;
    return acc;
  }, {});
};
